<template>
   <b-modal id="modalAddUnit" modal-class="modal-fullscreen" title="Voeg een eenheid toe" hide-backdrop
      size="md"
      @show="focusInput"
      @hidden="cleanupModal"
      @ok="handleUnitModalOk">
      <b-form ref="unitForm" @submit.stop.prevent="modalAddUnitSubmit()" >
        <b-form-group label="naam:" :invalid-feedback="naamInvalidInfo" :state="naamState">
          <b-form-input ref="inputNaam" class="col-6 px-1 px-sm-2" required :state="naamState"
            v-model="newUnit.naam" />
        </b-form-group>
        <b-form-group label="meervoud:">
          <b-form-input class="col-6 px-1 px-sm-2" v-model="newUnit.meervoud" />
        </b-form-group>
        <b-form-group label="afkorting:">
          <b-form-input class="col-6 px-1 px-sm-2" v-model="newUnit.afkorting" />
        </b-form-group>
      </b-form>
   </b-modal>
</template>
<script>

import db from "../db.js"

export default {
   name:"modal-add-unit",
   props: ["userID", "units"],
   data: function() {
      return {
         naamState: null,
         naamInvalidInfo: "Deze naam kan niet toegevoegd worden",
         newUnit: {id:null, naam: "", meervoud: "", afkorting: ""}
      };
   },
   computed: {
      unitId: function() {
         return (this.newUnit.naam
         .toLowerCase()
         .replace(/[^\w ]+/g, '')
         .replace(/ +/g, '-') + "-" + this.now)
      },
      now: function() {
         var date = new Date();
         return (
            String (date.getHours()) +
            String (date.getMinutes()) +
            String (date.getSeconds())
         )
      },
   },
   methods: {
      focusInput: function() {
         setTimeout(() => {
            this.$refs.inputNaam.focus()
         }, 500)
      },
      handleUnitModalOk: function(bvModalEvent) {
         bvModalEvent.preventDefault();
         this.modalAddUnitSubmit();
      },
      handleCancel: function() {
         this.newUnit = {id:null, naam: "", meervoud: "", afkorting: ""}
      },
      /**
       * 1) check of de naam is ingevuld
       * 2) check (hoofdletter-ongevoelig) of de eenheid niet al bestaat
       * 3) voeg de eenheid toe onder users/{uid}/units
       * 4) emit 'unitCreated' met het eenheid-object zodat de dropdown erop kan matchen
       * 5) sluit het venster
       */
      modalAddUnitSubmit: function() {
         this.naamState = true
         this.$refs.unitForm.checkValidity()
         this.newUnit.naam = this.newUnit.naam.trim()
         if(this.newUnit.naam == "") {
            this.naamState = false;
            this.naamInvalidInfo = "Geef een naam op"
         } else {
            for (let i = 0; i < this.units.length; i++) {
               const u = this.units[i];
               if(u.text && u.text.toLowerCase() == this.newUnit.naam.toLowerCase()) {
                  this.naamInvalidInfo = "Eenheid bestaat al"
                  this.naamState = false;
                  break;
               }
            }
         }
         if(!this.naamState) {
            return
         }
         this.newUnit.id = this.unitId
         const created = {
            id: this.newUnit.id,
            naam: this.newUnit.naam,
            meervoud: (this.newUnit.meervoud || "").trim(),
            afkorting: (this.newUnit.afkorting || "").trim(),
         }
         const unitRef = db.collection("users").doc(this.userID).collection("units").doc(created.id)
         unitRef.set(created).then(()=>{
               //no need to add to units: the onSnapshot in App.vue will add it to the clients units array
               this.$emit("unitCreated", created)
               this.$nextTick(()=> {
                  this.$bvModal.hide('modalAddUnit')
               })
         })
         .catch(error => {
            console.log(error)
         })
      },
      cleanupModal: function() {
            this.newUnit = {id:null, naam: "", meervoud: "", afkorting: ""}
      }
   },
}
</script>
